import type { PropsWithChildren, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Layout from './Layout';
type AuthShellProps = PropsWithChildren<{ title: string; alternateHref?: string; alternateLabel?: string; feedback?: ReactNode }>;
function AuthShell({ title, alternateHref, alternateLabel, feedback = null, children }: AuthShellProps) {
    return <Layout>
        <main className="auth-parchment">
            <div className="auth-illustration" aria-hidden="true"><span>Every adventure<br />begins with a character.</span></div>
            <section className="auth-form">
                <i className="fa-solid fa-compass auth-emblem" aria-hidden="true" />
                <h1>Character Forge</h1>
                <h2>{title}</h2>
                {alternateHref && alternateLabel && <Link to={alternateHref} className="mb-4 d-block">{alternateLabel}</Link>}
                {feedback}
                {children}
            </section>
        </main>
    </Layout>;
}
export default AuthShell;
